/**
 * What was played, in the players' own words. A handshake records a meeting;
 * the note records what the meeting turned out to be — "Shogi", "Blitz",
 * "Good" — and each side writes their own, so the two answers never have to
 * agree and neither is anybody else's to correct.
 */

/**
 * The pair of notes is read on one line under two usernames, so the limit is
 * the room that line has rather than a count of words. Three short ones fit.
 * Mirrors HANDSHAKE_NOTE_MAX_LENGTH on the server, which is what the column
 * and the endpoint actually hold anyone to.
 */
export const HANDSHAKE_NOTE_MAX_LENGTH = 24;

interface NotedHandshake {
  initiatorNote?: string | null;
  responderNote?: string | null;
}

/**
 * The notes on a handshake worth showing, in the order the names above them
 * are read. A side that said nothing leaves nothing behind, so one player
 * writing is a line of one rather than a line with a gap in it.
 */
export function handshakeNotes(handshake: NotedHandshake): string[] {
  return [handshake.initiatorNote, handshake.responderNote]
    .map((note) => note?.trim())
    .filter((note): note is string => !!note);
}

/** What is left of a note once the spacing a keyboard adds is taken off. */
export function tidyHandshakeNote(note: string): string {
  return note.trim().replace(/\s+/g, ' ').slice(0, HANDSHAKE_NOTE_MAX_LENGTH);
}
